function initListMap(){

    
    var view =  new ol.View({
        center: [0, 0],
        extent: [-180, -90, 180, 90],
        projection: 'EPSG:4326',
        zoom: 0
    });


    var map = new ol.Map({
      target: 'map',
      view:view
    });

    var svgContainer = document.createElement('div');
    var xhr = new XMLHttpRequest();
    xhr.open('GET', SKIN+'img/map.svg');
    xhr.addEventListener('load', function () {
      var svg = xhr.responseXML.documentElement;
      svgContainer.ownerDocument.importNode(svg);
      svgContainer.appendChild(svg);
    });
    xhr.send();

    var width = 1420;
    var height = 500;
    var svgResolution = 360 / width;
    svgContainer.style.width = width + 'px';
    svgContainer.style.height = height + 'px';
    svgContainer.style.transformOrigin = 'top left';
    svgContainer.className = 'svg-layer';


    map.addLayer(
      new ol.layer.Layer({
        render: function (frameState) {
          var scale = svgResolution / frameState.viewState.resolution;
          var center = frameState.viewState.center;
          var size = frameState.size;
          var cssTransform =  ol.transform.composeCssTransform(
            size[0] / 2,
            size[1] / 2,
            scale,
            scale,
            frameState.viewState.rotation,
            -center[0] / svgResolution - width / 2,
            center[1] / svgResolution - height / 2
          );
          svgContainer.style.transform = cssTransform;
          svgContainer.style.opacity = this.getOpacity();
          return svgContainer;
        },
      })
    );

    if($( ".marker-wrapper" ).length>0){
         var marker_points = [];
         $( ".marker-wrapper" ).each(function(index) {
              var  latitude = Number($( this ).data( "latitude" ));
              var  longtitude = Number($( this ).data( "longitude" ));
              var element = this;
              var pos = ol.proj.transform([longtitude, latitude ], 'EPSG:4326', 'EPSG:4326');
             
              var marker = new ol.Overlay({
                 element: element,
                 position: pos,
                 positioning: 'center-center'
             });
              marker_points.push([longtitude, latitude ]);
             map.addOverlay(marker);

         });

         // var layerExtent =  ol.extent.boundingExtent(marker_points) ;
          //    layerExtent = ol.proj.transformExtent(layerExtent, ol.proj.get('EPSG:4326'), ol.proj.get('EPSG:3857'));
          //    view.fit(layerExtent, {size:map.getSize(),padding:[100, 100, 100, 100]} );
     }

    setTimeout(function(){
         map.updateSize();
    }, 500);
   
   
     $('.marker').click(function(){
         $('div.ol-popup').hide();
         $(this).parent().find('div.ol-popup').show();
         return false;
    });

      $('.ol-popup-closer').click(function(){
         $('div.ol-popup').hide();
         return false;
    });

}
  function initContactForm() {
    $('form[name="contact-form"]').validate({
      submitHandler: function () {
        $.ajax({data: $('form[name="contact-form"]').serialize(),
          success: function (data) {
            if (data.status == "ok") {
              $('form[name="contact-form"] .alert-success').show();
              registerGAEvent('contact_form_submit','success');
               setTimeout(function(){ 
                window.location.reload();    
              }, 3000);

            } else {
              alert(data.error);
              registerGAEvent('contact_form_submit','error');
            }
          }
        });
        return false;
      },
      rules: {
        name: "required",
        company_name: "required",
        job_position: "required",
        interested: "required",
        email: {
          required: true,
          email: true
        },
        country: "required",
        message: "required"
      },
      highlight: function (element, errorClass, validClass) {
        if($(element).is(':radio')){
          $(element).parent().parent().addClass(errorClass);
        }else{
          $(element).parent().addClass(errorClass);
        }


      },
      unhighlight: function (element, errorClass, validClass) {
        if($(element).is(':radio')){
          $(element).parent().parent().removeClass(errorClass);
        }else{
          $(element).parent().removeClass(errorClass);
        }
      },
      messages: {
        name: " ",
        company_name: " ",
        job_position: " ",
        email: " ",
        country: " ",
        message: " "
      },
      errorPlacement: function (error, element) {
        element.parent();
      }
    });
  }